/**
 * @summary - Component that Provides Maintenance Year Details
 * @author Purushothaman T
 * @since 2024-05-30
 */
import { Box, Stack } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { DefaultCard } from "../../assets/styled-components/card";
import { maintainYear } from "../../utility/constants/masters";
import { MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CloseButton from "../commoncomponents/CloseButton";
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from "../commoncomponents/SectionTitle";
import { useAccess } from "../../AccessContext";

function MaintenanceYearList() {
  const column = maintainYear.gridColumn;
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState({});
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setRowData([]);
    setIsLoading(true);
    try {
      // Obtain the bearer token from local storage or your state management system
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId("facilityId");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const maintenanceYearResponse = await axios.get(
        `${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
          filterModel
        )}&sortOptions=${JSON.stringify(sortModel)}`, config);
      setRowCount(maintenanceYearResponse.data.totalCount);
      setExportCount(maintenanceYearResponse.data.totalCount);
      setRowData(
        maintenanceYearResponse.data.items.map((item) => {
          return {
            ...item,
            enddate: utils.formatDate({
              dateString: item.enddate,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
            startdate: utils.formatDate({
              dateString: item.startdate,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
          };
        })
      );
    } catch (error) {
      console.error("Error fetching options:", error);

    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filterModel, sortModel, pageIndex, pageSize]);

  const fetchExportdata = async () => {

    try {
      // Obtain the bearer token from local storage or your state management system
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId("facilityId");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const maintenanceYearResponse = await axios.get(
        `${MasterGraph}/api/CommonExport/CommonExportData/${facilityId}/maintenanceyear?filterOptions=${JSON.stringify(
          filterModel
        )}&sortOptions=${JSON.stringify(sortModel)}`, config);

      setExportData(
        maintenanceYearResponse.data.maintenanceYears.map((item) => {
          return {
            ...item,
            enddate: utils.formatDate({
              dateString: item.enddate,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
            startdate: utils.formatDate({
              dateString: item.startdate,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
          };
        })
      );
    } catch (error) {
      console.error("Error fetching options:", error);

    }
  };


  const colDefs = [
    {
      field: column.maintainyear.field,
      headerName: column.maintainyear.header,
    },
    {
      field: column.startdate.field,
      headerName: column.startdate.header,
      filter:false,
      sort:false
    },
    {
      field: column.enddate.field,
      headerName: column.enddate.header,
      filter:false,
      sort:false
    },
    { field: column.weekvalue.field, headerName: column.weekvalue.header },
  ];
  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([])
  };
  return (
    <>
      <PageTitle title={"Maintenance Year Details"} />
      <DefaultCard>
        <Stack mb={1} direction={"row"} justifyContent={"space-between"}>
          <SectionTitle title={"Maintenance Year Details List"} />
          <RefreshExportButtons
            //exportFunction={() => { }}
            // handleRefresh={fetchData}
            handleRefresh={handleRefresh}
            exportFunction={fetchExportdata}
            exportData={exportData}

            refData={gridApi}
            title={"Maintenance Year Details"}
          />
        </Stack>
        <Box>
          <CustomAgGrid
            rows={rowData}
            columns={colDefs}
            refSet={gridApi}
            totalCount={rowCount}
            pageIndex={pageIndex}
            pagination={false}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
            setGridApi={setGridApi}
            isDateComparator={true}
            isLoading={isLoading}
          />
        </Box>
      </DefaultCard>
      <CloseButton />
    </>
  );
}
export default MaintenanceYearList;
